import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'redux-bundler-react';
import SearchFormV2 from 'components/molecules/SearchFormV2';

export default connect('doUpdateUrl', SearchFormV2);
